/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserActivity } from './userActivity';

export type UserContextInputActivity = UserActivity[] | null;
